export default "__VITE_ASSET__Dd48_RPN__"